













import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
  name: 'test-alert'
})
export default class TestAlert extends Vue {
  @Prop({type: Boolean, default: false}) protected show!: boolean
}
